import { useState } from "react";
import { Newspaper, History, AlertTriangle } from "lucide-react";

export const STALE_DAYS = 5;

export const daysAgo = (iso) => {
  if (!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
};

export const isStale = (posts) => {
  const d = daysAgo(posts?.written_at);
  return d === null || d >= STALE_DAYS;
};

const ageLabel = (d) => (d === null ? "date unknown" : d === 0 ? "written today" : d === 1 ? "written yesterday" : `written ${d} days ago`);

export const PostHook = ({ posts }) => {
  if (!posts?.x) return null;
  const d = daysAgo(posts.written_at);
  const stale = isStale(posts);
  return (
    <div className="flex flex-wrap items-start gap-x-3 gap-y-1 text-xs" data-testid="post-hook">
      {posts.hook && (
        <span className="inline-flex items-start gap-1.5 text-slate-600">
          <Newspaper className="w-3 h-3 mt-0.5 shrink-0 text-[var(--accent)]" />
          <span>
            <span className="font-medium text-[#0A192F]">Hook:</span> {posts.hook}
            {posts.hook_source_url && (
              <>
                {" "}
                <a href={posts.hook_source_url} target="_blank" rel="noopener noreferrer" data-testid="post-hook-source" className="text-[var(--accent)] hover:text-[#0A192F] underline underline-offset-2">source</a>
              </>
            )}
            {posts.hook_is_fallback && <span className="ml-1 text-amber-600">(field topic — nothing fresh on them this week)</span>}
          </span>
        </span>
      )}
      <span data-testid="post-age" className={`inline-flex items-center gap-1 ${stale ? "text-amber-600" : "text-slate-400"}`}>
        {stale && <AlertTriangle className="w-3 h-3" />}
        {ageLabel(d)}{stale ? " · stale, will be rewritten before the next email" : ""}
      </span>
    </div>
  );
};

export const PostHistory = ({ history }) => {
  const [open, setOpen] = useState(false);
  if (!history?.length) return null;
  const rows = [...history].reverse();
  return (
    <div className="pt-2" data-testid="post-history">
      <button type="button" data-testid="post-history-toggle" onClick={() => setOpen((v) => !v)} className="inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-[#0A192F]">
        <History className="w-3 h-3" /> {open ? "Hide" : "Show"} previous posts ({rows.length})
      </button>
      {open && (
        <ul className="mt-2 space-y-2 border-l-2 border-slate-100 pl-3">
          {rows.map((p, i) => (
            <li key={`${p.written_at}-${i}`} className="text-xs text-slate-500">
              <div className="text-[10px] uppercase tracking-wider text-slate-400">{p.written_at?.slice(0, 10)} · {p.hook || "no hook recorded"}</div>
              <div className="text-slate-600 mt-0.5">{p.x}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
